import { areaLevelAtom, firstAreaAtom, isMenuOpenAtom } from "@/api/atoms";
import { capitalizeFirstLetter } from "@/utils";
import { UilAngleDown } from "@iconscout/react-unicons";
import { useAtom, useAtomValue } from "jotai";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";

import { InfoCard } from "./InfoCard";

const DraggableMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useAtom(isMenuOpenAtom);
  const firstArea = useAtomValue(firstAreaAtom);
  const areaLevel = useAtomValue(areaLevelAtom);

  const isEngland = firstArea?.name === "United Kingdom";
  const title = `${firstArea ? (isEngland ? "England -" : "Total") : capitalizeFirstLetter(areaLevel)} Bike thefts`;

  return (
    <SwipeableBottomSheet
      overflowHeight={340}
      marginTop={192}
      open={isMenuOpen}
      onChange={setIsMenuOpen}
      style={{
        position: "absolute",
        paddingInline: 20,
      }}
    >
      <div className="rounded-t p-5">
        <UilAngleDown
          className={`mx-auto mb-3 transform text-white transition-all duration-200 ${
            isMenuOpen ? "rotate-180" : ""
          }`}
        />
        <InfoCard title={title} />
      </div>
    </SwipeableBottomSheet>
  );
};

export default DraggableMenu;
